import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { EngineNumberMonitoringStates } from "./types/EngineNumberMonitoringTypes";
import { Button, Col, Divider, Form, Input, Modal, Result, Image, Row, Spin, Tabs, Tooltip, Tag } from "antd";
import { FormOutlined, LeftOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";

const { TabPane } = Tabs;

export interface EngineNumberMonitoringProps {}

class EngineNumberMonitoring extends Component<EngineNumberMonitoringProps & any, EngineNumberMonitoringStates> {
  private readonly initState!: EngineNumberMonitoringStates;

  constructor(props: (EngineNumberMonitoringProps & any) | any) {
    super(props);
    this.initState = {
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      orderMonth: moment().clone().format("YYYY-MM"),
      fetchData: false,
      dataStock: {},
      tabKey: "1",
      finalLoadingData: false,
      listResult: [],
      vehicleEngineNumber: "",
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  cancelProcess = async () => {
    await this.promisedSetState({
      tabKey: "1",
      dataStock: {},
    });
  };

  fetchDataStock = async () => {
    if (!this.state.vehicleEngineNumber) {
      Modal.error({
        title: "Error",
        content: "Lengkapi Data Nomor Mesin",
      });
      return;
    }

    await this.promisedSetState({
      fetchData: true,
      dataStock: {},
      finalLoadingData: true,
    });

    try {
      await stockOtodisService
        .getStock({
          // dealerCode: this.state.dealerCode,
          vehicleEngineNumber: this.state.vehicleEngineNumber?.trim(),
        })
        .then(async (value) => {
          await this.promisedSetState({
            tabKey: "2",
            fetchData: false,
            finalLoadingData: false,
            dataStock: value.data.data,
          });
        });
    } catch (e) {
      await this.promisedSetState({
        tabKey: "1",
        fetchData: false,
        finalLoadingData: false,
        dataStock: {},
      });
      Modal.error({
        title: "Proses Gagal",
        content: "" + e,
      });
    }
  };

  onFieldChange = <T extends keyof Pick<any, "vehicleEngineNumber">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "vehicleEngineNumber":
        currentState.vehicleEngineNumber = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Monitoring Nosin`}
          defaultSelectedKeys={["m-engine-number-monitoring"]}
          defaultOpenKeys={["sm-stock", "sm-sm-stock"]}
        >
          <Tabs activeKey={this.state.tabKey.toString()}>
            <TabPane tab="Cari Data Nomor Mesin" disabled={true} key="1">
              <Result
                icon={<FormOutlined />}
                title="Pencarian data berdasarkan nomor mesin"
                extra={
                  <div>
                    <Row>
                      <Col xs={24} xl={6} className={`pad-10`} />
                      <Col xs={24} xl={12} className={`pad-10`}>
                        <Form.Item>
                          <i className={`small-text-grey`}>Nomor Mesin</i>
                          <Input value={this.state.vehicleEngineNumber} onChange={(event) => this.onFieldChange("vehicleEngineNumber", event.target.value)} placeholder="Nomor Mesin" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6} className={`pad-10`} />
                    </Row>

                    <br />
                    <Button onClick={this.fetchDataStock} loading={this.state.fetchData} type="primary" icon={<SearchOutlined />}>
                      Cari Stock
                    </Button>
                  </div>
                }
              />
            </TabPane>
            <TabPane tab="Hasil Data" disabled={true} key="2">
              <div>
                <Tooltip title="Cari Nomor Mesin">
                  <Button shape="circle" icon={<LeftOutlined />} onClick={this.cancelProcess} />
                </Tooltip>
              </div>
              <br />

              <Row>
                <Col xs={24} xl={14} className={`pad-10`}>
                  <Divider orientation="left" plain>
                    <span className={`divider-stock-purchase`}>Gudang & Supplier</span>
                  </Divider>
                  <Row>
                    <Col span={8} className={`col-grey`}>
                      Kode Stock Unit:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.stock_unit_code}</Col>
                    <Col span={8} className={`col-grey`}>
                      Gudang:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.warehouse_name}</Col>
                    <Col span={8} className={`col-grey`}>
                      Supplier:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.supplier_name}</Col>
                    <Col span={8} className={`col-grey`}>
                      Status Stock:
                    </Col>
                    <Col span={16}>
                      {this.state.dataStock[0]?.stock_status === "SOLD" ? (
                        <Tag color="#cd201f">{this.state.dataStock[0]?.stock_status}</Tag>
                      ) : (
                        <Tag color="#40a9ff">{this.state.dataStock[0]?.stock_status}</Tag>
                      )}
                    </Col>
                    <Col span={8} className={`col-grey`}>
                      Tanggal Stock Tercatat di Sistem:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.create_date}</Col>
                    <Col span={8} className={`col-grey`}>
                      Tanggal SJ:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.stock_delivery_create_date}</Col>
                    <Col span={8} className={`col-grey`}>
                      Tanggal HK:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.stock_debit_note_date}</Col>
                    <Col span={8} className={`col-grey`}>
                      No SJ:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.stock_delivery_order_number}</Col>
                    <Col span={8} className={`col-grey`}>
                      No HK:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.stock_debit_note_number}</Col>
                    <Col span={8} className={`col-grey`}>
                      Status HK:
                    </Col>
                    {this.state.dataStock[0]?.vehicle_fixed_purchase_price <= 0 ? <Tag color="#cd201f">BELUM HK</Tag> : <Tag color="#1fcd3c">SUDAH HK</Tag>}
                  </Row>

                  <Divider orientation="left" plain>
                    <span className={`divider-stock-purchase`}>Kendaraan</span>
                  </Divider>
                  <Row>
                    <Col span={8} className={`col-grey`}>
                      Merk Kendaraan:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.vehicle_brand_name}</Col>
                    <Col span={8} className={`col-grey`}>
                      Model Kendaraan:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.vehicle_model_name}</Col>
                    <Col span={8} className={`col-grey`}>
                      Variant Kendaraan:
                    </Col>
                    <Col span={16}>
                      {this.state.dataStock[0]?.vehicle_variant_code} - {this.state.dataStock[0]?.vehicle_variant_name}
                    </Col>
                    <Col span={8} className={`col-grey`}>
                      Warna Kendaraan:
                    </Col>
                    <Col span={16}>
                      {this.state.dataStock[0]?.vehicle_color_code} - {this.state.dataStock[0]?.vehicle_color_name}
                    </Col>
                    <Col span={8} className={`col-grey`}>
                      Nomor Rangka:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.vehicle_chassis_number}</Col>
                    <Col span={8} className={`col-grey`}>
                      Nomor Mesin:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.vehicle_engine_number}</Col>
                    <Col span={8} className={`col-grey`}>
                      Tahun Kendaraan:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.vehicle_year}</Col>
                    <Col span={8} className={`col-grey`}>
                      Kondisi Kendaraan:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.stock_condition}</Col>
                    <Col span={8} className={`col-grey`}>
                      Catatan:
                    </Col>
                    <Col span={16}>{this.state.dataStock[0]?.notes}</Col>
                  </Row>
                </Col>
                <Col xs={24} xl={10} className={`pad-10`}>
                  <Divider orientation="left" plain>
                    <span className={`divider-stock-purchase`}>Gambar Gesekan Nosin</span>
                  </Divider>
                  <Image src={this.state.dataStock[0]?.vehicle_engine_document} alt={"=== TIDAK ADA GAMBAR GESEKAN NOSIN ==="} />
                </Col>
              </Row>
            </TabPane>
          </Tabs>

          <Modal visible={this.state.finalLoadingData} closeIcon={true} footer={null}>
            <div style={{ textAlign: "center", padding: 20, minHeight: 100 }}>
              <Spin style={{ marginTop: 20 }} size={"large"} tip="Processing..." />
            </div>

            <div style={{ textAlign: "center", padding: 20 }}>
              Proses pencarian data <br />
              Mohon menunggu beberapa saat.
            </div>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(EngineNumberMonitoring), 24);
